import React from 'react';
import Icon from 'components/mweb/Icon/Icon';
import Button from 'components/common/Button/Button';
import { RUPEE_SYMBOL } from 'hb-redux-store/util/constantServices';

const PreferredPayment = props => {
  const {
    title = 'Preferred Payment',
    selectedMode,
    onPaymentModeChange,
    onPlaceOrder,
    details: { hbWalletAmount },
  } = props;
  const podModes = [
    {
      key: 'hbw',
      title: 'VXL Money',
      isActive: true,
      message: '',
      icon: 'icon-hb-money-wallet',
    },
  ];
  const onPay = pMode => {
    const payDetails = { mode: pMode.key, ...props.details };
    onPlaceOrder(payDetails);
  };
  const onModeClick = pMode => {
    if (pMode.isActive) {
      onPaymentModeChange(pMode.key);
    }
  };
  return (
    <React.Fragment>
      <div className="desktop-payment-mode-panel cod">
        <div className="desktop-payment-mode-panel--title">{title}</div>
        {podModes.length > 0 &&
          podModes.map((pMode, index) => (
            <React.Fragment key={pMode.key}>
              <div
                className={[
                  'desktop-payment-mode-panel--item',
                  selectedMode === pMode.key ? 'active' : '',
                  index === podModes.length - 1 ? 'last-item' : '',
                ].join(' ')}
                onClick={() => onModeClick(pMode)}
              >
                <div
                  className={`flex-align-items-center ${
                    !pMode.isActive ? 'cod-disabled' : ''
                  }`}
                >
                  <div className="desktop-payment-mode-panel--item--illustration">
                    <Icon class={pMode.icon} height={26} width={45} />
                  </div>
                  <div className="desktop-payment-mode-panel--item--name">
                    <div className="justify-content--space-between">
                      <span>{pMode.title}</span>
                      <span>
                        <span>Balance: </span>
                        <span className="bold">
                          {RUPEE_SYMBOL}
                          {hbWalletAmount}
                        </span>
                      </span>
                    </div>
                  </div>
                  {pMode.isActive && (
                    <div className="desktop-payment-mode-panel--item--radio">
                      {selectedMode === pMode.key ? (
                        <Icon size={17} class="icon-common-radio-selected" />
                      ) : (
                        <Icon size={17} class="icon-common-radio-unselected" />
                      )}
                    </div>
                  )}
                </div>
                <div className="flex-align-items-center desktop-payment-mode-panel--faster-checkout">
                  <Icon size={20} class="icon-hb-money-faster-checkout" />
                  <span>Experience Faster Checkout</span>
                </div>
                {pMode.message && (
                  <div className="cod-disabled-message">{pMode.message}</div>
                )}
              </div>
              {selectedMode === pMode.key && (
                <div className="cod-cta">
                  <Button
                    className="button button-primary medium"
                    onClick={() => onPay(pMode)}
                  >
                    {props.details.differenceAmount
                      ? `Add & Place Order`
                      : `Pay & Place Order`}
                  </Button>
                </div>
              )}
            </React.Fragment>
          ))}
      </div>
      <div className="desktop-payments-section-divider" />
    </React.Fragment>
  );
};

export default PreferredPayment;
